import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Configurar Capacitor en plataforma nativa
if (Capacitor.isNativePlatform()) {
  SplashScreen.hide();
  StatusBar.setStyle({ style: Style.Dark });
  StatusBar.setBackgroundColor({ color: '#0f0f1e' });
}

// Registrar Service Worker para PWA (solo en web, no en nativo)
if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registrado:', registration.scope);

        // Verificar actualizaciones cada 5 minutos
        setInterval(() => {
          registration.update();
        }, 5 * 60 * 1000);
      })
      .catch((error) => {
        console.log('Error al registrar Service Worker:', error);
      });
  });

  // Detectar cuando hay una nueva versión disponible
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (window.confirm('Nueva version disponible. Recargar la pagina?')) {
      window.location.reload();
    }
  });
}
